import styled from 'styled-components';

import { space3XL } from '@xing-com/tokens';

export const Wrapper = styled.nav`
  display: flex;
  min-width: 100%;
  justify-content: center;
  margin-top: ${space3XL};
`;

export const PaginationList = styled.ol`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0;
  list-style-type: none;
`;

export const Ellipsis = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  min-height: 36px;
  cursor: default;
  user-select: none;
`;
